var $583f94d807f6ecea$exports = {};
$583f94d807f6ecea$exports = {
    "Empty": `Leeg`
};


export {$583f94d807f6ecea$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
